import { MenuItem } from "./MenuItem";
import { IMenuItem } from "../../models";
import { MENU_LIST, VERSION_NUMBER } from "../../constants";
import React from "react";

export const MenuItemsList = React.memo(() => {
	return (
		<>
			<div className="flex flex-col grow ch-border-right">
				<div>
					{(MENU_LIST as IMenuItem[]).map((menuItem) => (
						<MenuItem key={menuItem.route ?? menuItem.label} {...menuItem} />
					))}
				</div>
				<div className="py-4" style={{ fontSize: 14, paddingLeft: 20 }}>
					<span className="mr-2">Version</span>
					{VERSION_NUMBER}
				</div>
			</div>
		</>
	);
});
